@if (isVisible) {
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ 'Gallery' | translate }} ({{ photos.length }})</h3>
      <button class="btn-close" (click)="onClose()">×</button>
    </div>
    <div class="modal-body">
      @if (photos.length === 0) {
      <div class="no-photos">
        {{ 'No photos available' | translate }}
      </div>
      } @else {
      <div class="photo-grid">
        @for (photo of photos; track photo.id; let i = $index) {
        <div class="photo-item" (click)="openFullScreen(i)">
          <img [src]="getImageUrl(photo.fileStorageId)" loading="lazy" [alt]="photo.title">
          <div class="photo-info" *ngIf="photo.title">
            <span>{{ photo.title }}</span>
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>

@if (selectedPhotoIndex > -1) {
<div class="lightbox-overlay" (click)="closeFullScreen()">
  <button class="lightbox-close" (click)="closeFullScreen()">×</button>
  <button class="nav-btn prev" [disabled]="selectedPhotoIndex === 0" (click)="prevPhoto($event)">
    &#10094;
  </button>
  <div class="lightbox-content" (click)="$event.stopPropagation()">
    <img [src]="getImageUrl(photos[selectedPhotoIndex].fileStorageId)" [alt]="photos[selectedPhotoIndex].title">
    <div class="lightbox-caption">
      {{ photos[selectedPhotoIndex].title }}
      ({{ selectedPhotoIndex + 1 }} / {{ photos.length }})
    </div>
  </div>
  <button class="nav-btn next" [disabled]="selectedPhotoIndex === photos.length - 1" (click)="nextPhoto($event)">
    &#10095;
  </button>
</div>
}
}
